/* HURT — reveal-on-scroll for homepage sections. Content stays visible if JS or IntersectionObserver is missing. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var targets = document.querySelectorAll('.hb-head, .hb-card, .hb-look__item, .hb-community__content, .hb-reviews__app');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  targets.forEach(function (el, i) {
    if (el.getBoundingClientRect().top < window.innerHeight) return; // already on screen: leave as is
    el.classList.add('hb-reveal');
    el.style.transitionDelay = (i % 4) * 70 + 'ms';
    io.observe(el);
  });
})();
